module.exports = __webpack_public_path__ + "static/media/yiyuan12.c0bec3e3.png";